import { useTranslations } from 'next-intl';

import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import FeaturedTile from '@commons/components/Tile/FeaturedTile';
import { FEATURED_TILE_IMAGE_SIZES } from '@commons/components/Tile/FeaturedTile';

import type { IntelligenceNodeProps } from '.';

/**
 * Intelligence node component for the Featured Tile display type.
 */

const IntelligenceNodeFeaturedTile = ({ image, title, summary, alias }: IntelligenceNodeProps) => {
  const t = useTranslations();

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={FEATURED_TILE_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={FEATURED_TILE_IMAGE_SIZES} />
  );

  return (
    <FeaturedTile
      tag={t('nodes.intelligence.label')}
      title={title}
      description={summary}
      buttonText={t('commons.learnMore')}
      href={alias}
      image={renderedImage}
      justify="space-between"
      aspectRatio="portrait"
      className="w-100"
    />
  );
};

export default IntelligenceNodeFeaturedTile;
